interface FieldItemViewProps {
    textValueStyle?: string,
    lable: string,
    value: any,
    classNames?: string
}

const FieldItemView = ({ textValueStyle, lable, value, classNames }: FieldItemViewProps) => {
    return (
        <div className={classNames}>
            <p className='font-medium'>{lable}</p>
            <span
                className={textValueStyle}
            >
                {value !== null && value !== undefined && value !== '' ? value : '--'}
            </span>
        </div>
    );
};

export default FieldItemView;
